export const polstRejectReasonsData = [
  {text: 'Physician/NP/PA Signature Missing.'},
  {text: 'Missing Patient or Legally Recognized Decisionmaker signature.'},
  {text: 'Form is not legible.'},
  {text: 'Missing front page of POLST form.'},
  {text: 'Missing date form was prepared.'},
  {text: 'Form has different patient information.'},
  {text: 'Patient refused to sign.'},
  {text: 'Invalid signatures.'},
  {text: 'A POLST must be filled out in English.'}
];
